import { StorageFile } from "api/model/StorageFile";

interface TrackCourse {
    name: string;
    image?: StorageFile;
}

export interface Track {
    id: string;
    name: string;
    country: string;
    friendlyName: string;
    description: string;
    courses?: TrackCourse[];
}

export const TrackFormDefault: Track = {
    id: "",
    name: "",
    country: "",
    friendlyName: "",
    description: "",
    courses: [],
};
